<app-admin-header
  style="width: 100%"
  [header]="header"
  [links]="links"
  [breadcrumbs]="breadcrumbs"
  [stats]="[]"
></app-admin-header>
<div class="w-100">
  <app-skelitions
    [hidden]="!skelition"
    [value]="2"
    class="mb-2"
  ></app-skelitions>
</div>
<section *ngIf="!skelition" class="container-fluid ms-main-bg py-5 bbbb">
  <div class="container ms-pg-structure">
    <div class="d-flex-between-mob-column">
      <div>
        <h4 class="large-h">{{ "Factors History - Reports" | translator }}</h4>
      </div>
    </div>
    <div class="">
      <div class="grey-box">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-12">
            <div class="column my-2 pppp-drop">
              <h5 class="medium-h">{{ "search" | translator }}</h5>
              <p-dropdown
                [options]="projects"
                [(ngModel)]="selectProject"
                optionLabel="name"
                appendTo="body"
                (onChange)="onProjectChange()"
                placeholder="{{ 'Project' | translator }}"
              ></p-dropdown>
            </div>
          </div>
          <div *ngIf="selectProject" class="col-lg-3 col-md-6 col-12">
            <div class="column my-2 pppp-drop">
              <h5 class="medium-h">&nbsp;</h5>
              <p-dropdown
                [options]="basicChannels"
                [(ngModel)]="selectChanel"
                optionLabel="name"
                appendTo="body"
                (onChange)="onChannelChange()"
                [placeholder]="'Select Channel' | translator"
              ></p-dropdown>
            </div>
          </div>
          <div
            *ngIf="
              hasBranches && selectChanel && selectChanel.name == 'Branches'
            "
            class="col-lg-3 col-md-6 col-12"
          >
            <div class="column my-2 pppp-drop">
              <h5 class="medium-h">&nbsp;</h5>
              <p-dropdown
                [options]="selectedBranches"
                [(ngModel)]="selectBranch"
                optionLabel="name"
                appendTo="body"
                [placeholder]="'Select Branch' | translator"
              ></p-dropdown>
            </div>
          </div>
        </div>
        <app-no-data
          *ngIf="filteredFactors.length <= 0 && selectProject"
        ></app-no-data>
        <h4 *ngIf="filteredFactors.length > 0" class="medium-h my-4 mx-2">
          {{ "Factors List" | translator }}
        </h4>
        <div *ngIf="filteredFactors.length > 0" class="grey-box">
          <table>
            <thead>
              <tr>
                <th scope="col" style="width: 3%">#</th>
                <th scope="col" style="width: 30%">
                  {{ "Factor" | translator }}
                </th>
                <th scope="col" style="width: 7%">
                  {{ "Percentage" | translator }}
                </th>
                <th scope="col" style="width: 20%">
                  {{ "Mystery Shopper Comment" | translator }}
                </th>
                <th scope="col" style="width: 15%">
                  {{ "Responsible" | translator }}
                </th>
                <th scope="col" style="width: 10%">
                  {{ "Status" | translator }}
                </th>
                <th scope="col" style="width: 15%">
                  {{ "Responsible comments" | translator }}
                </th>
                <th scope="col" style="width: 5%">
                  {{ "Action" | translator }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let factor of filteredFactors; let i = index">
                <td data-label="">
                  <span class="ms-tabel-td-mob-mr">
                    <div
                      class="d-flex tab-num-border-white v4-ms-input-white-pg-5 mb-0"
                    >
                      <div>
                        <div class="ms-tabel-num-box">
                          {{ i + 1 }}
                        </div>
                      </div>
                    </div>
                  </span>
                </td>
                <td data-label="Factor">
                  <span class="ms-tabel-td-mob-mr">
                    <div
                      [pTooltip]="factor?.factor_details?.factor"
                      tooltipPosition="top"
                      class="v4-ms-input-white-pg-5 form-control mb-0"
                    >
                      {{ factor?.factor_details?.factor.substring(0, 15) }}
                      {{
                        factor?.factor_details?.factor.length > 15
                          ? "..."
                          : null
                      }}
                    </div>
                  </span>
                </td>
                <td data-label="Percentage">
                  <span class="ms-tabel-td-mob-mr">
                    <div class="v4-ms-input-white-pg-5 mb-0">
                      {{ factor?.factors?.percentage }}
                    </div>
                  </span>
                </td>
                <td
                  data-label="Responsible Comments"
                  [ngStyle]="{ 'margin-top': '10px' }"
                >
                  <span
                    class="ms-tabel-td-mob-mr d-flex align-items-center justify-content-start"
                  >
                    <div
                      [pTooltip]="factor?.factors?.msComments"
                      tooltipPosition="top"
                      class="v4-ms-input-white-pg-5 form-control mb-0"
                    >
                      {{ factor?.factors?.msComments.substring(0, 15) }}
                      {{
                        factor?.factors?.msComments.length > 15 ? "..." : null
                      }}
                    </div>
                  </span>
                </td>
                <td
                  data-label="Responsible"
                  [ngStyle]="{ 'margin-top': '10px' }"
                >
                  <span
                    class="ms-tabel-td-mob-mr d-flex align-items-center justify-content-start"
                  >
                    <input
                      [value]="
                        getResponsibleName(
                          factor?.factorResponsible?.responsible
                        )
                      "
                      type="text"
                      [disabled]="true"
                      class="form-control v4-ms-input-white-pg-5 mb-0"
                    />
                  </span>
                </td>
                <td
                  data-label="Responsible Comments"
                  [ngStyle]="{ 'margin-top': '10px' }"
                >
                  <span
                    class="ms-tabel-td-mob-mr d-flex align-items-center justify-content-start"
                  >
                    <input
                      [value]="factor?.factorResponsible?.status | translator"
                      type="text"
                      [disabled]="true"
                      class="form-control v4-ms-input-white-pg-5 mb-0"
                    />
                  </span>
                </td>
                <td
                  data-label="Responsible Comments"
                  [ngStyle]="{ 'margin-top': '10px' }"
                >
                  <span
                    class="ms-tabel-td-mob-mr d-flex align-items-center justify-content-start"
                  >
                    <input
                      [value]="
                        factor?.factorResponsible?.rsComments
                          ? factor?.factorResponsible?.rsComments
                          : ''
                      "
                      type="text"
                      [disabled]="true"
                      class="form-control v4-ms-input-white-pg-5 mb-0"
                    />
                  </span>
                </td>
                <td data-label="Status">
                  <span
                    class="ms-tabel-td-mob-mr adjust d-flex align-items-center justify-content-start"
                  >
                    <div
                      [pTooltip]="'View History' | translator"
                      (click)="LoadHistory(factor._id)"
                      class="circle-bt"
                    >
                      <i class="pi pi-eye"></i>
                    </div>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div *ngIf="factorHistory" class="">
      <div class="grey-box">
        <h4 class="medium-h my-4 mx-2">{{ "History" | translator }}</h4>
        <app-no-data
          *ngIf="factorHistory.length <= 0 && viewHistory"
        ></app-no-data>
        <div *ngIf="factorHistory.length > 0" class="">
          <table>
            <tbody>
              <tr *ngFor="let history of factorHistory; let j = index">
                <td style="width: 0px" data-label="">
                  <span class="ms-tabel-td-mob-mr vvvvv">
                    <div class="d-flex tab-num-border-white">
                      <div>
                        <div class="ms-tabel-num-box">
                          {{ j + 1 }}
                        </div>
                      </div>
                    </div>
                  </span>
                </td>
                <td
                  data-label="Responsible Comments"
                  [ngStyle]="{ 'margin-top': '10px' }"
                >
                  <span
                    class="ms-tabel-td-mob-mr d-flex align-items-center justify-content-start"
                  >
                    <input
                      [value]="extractUsername(history.userId.name)"
                      type="text"
                      [disabled]="true"
                      class="form-control v4-ms-input-white-pg-5"
                    />
                  </span>
                </td>
                <td
                  data-label="Responsible Comments"
                  [ngStyle]="{ 'margin-top': '10px' }"
                >
                  <span
                    class="ms-tabel-td-mob-mr d-flex align-items-center justify-content-start"
                  >
                    <input
                      [(ngModel)]="history.comments"
                      type="text"
                      [disabled]="true"
                      class="form-control v4-ms-input-white-pg-5"
                    />
                  </span>
                </td>
                <td
                  data-label="Responsible Comments"
                  [ngStyle]="{ 'margin-top': '10px' }"
                >
                  <span
                    class="ms-tabel-td-mob-mr d-flex align-items-center justify-content-start"
                  >
                    <input
                      [value]="history.status | translator"
                      type="text"
                      [disabled]="true"
                      class="form-control v4-ms-input-white-pg-5"
                    />
                  </span>
                </td>
                <td
                  data-label="Responsible Comments"
                  [ngStyle]="{ 'margin-top': '10px' }"
                >
                  <span
                    class="ms-tabel-td-mob-mr d-flex align-items-center justify-content-start"
                  >
                    <input
                      [value]="formatDate(history.createdAt)"
                      type="text"
                      [disabled]="true"
                      class="form-control v4-ms-input-white-pg-5"
                    />
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</section>
<p-confirmDialog [style]="{ margin: '0rem 1rem' }"></p-confirmDialog>
<app-footer></app-footer>
